module.exports = __webpack_public_path__ + "static/ticket_checker_help3-a3da1289beff620afec8491b808042d1.jpg";